<div *ngIf="field" class="address-search">
  <mat-icon
    *ngIf="!modalOpen"
    class="address-search__icon"
    matPrefix
    [svgIcon]="field.icon"
    role="presentation"
  ></mat-icon>
  <input
    [formControl]="address"
    type="text"
    class="address-search__input"
    [class.address-search__input--error]="error$ | async"
    #locationTextfieldRef
    matInput
    (focus)="locationIsFocused = true"
    (blur)="locationIsFocused = false"
    [matAutocomplete]="auto"
    [placeholder]="field.placeholder"
    [attr.aria-label]="field.ariaLabel"
  />
  <button
    type="button"
    *ngIf="!!address.value"
    class="delete-btn btn-clean address-search__btn-delete"
    [attr.aria-label]="'Suppression du filtre ' + field.ariaLabel | lowercase | upperfirst"
    (click)="clearValue()"
    matSuffix
  >
    <mat-icon svgIcon="cross" class="address-search__icon--delete" role="presentation"></mat-icon>
  </button>
  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    class="dropdown-panel"
    [displayWith]="displayFn"
    (optionSelected)="selectValue($event.option.value)"
    (closed)="onClose()"
    panelWidth="auto"
  >
    <ng-container *ngIf="cities$ | async as cities">
      <mat-optgroup *ngIf="cities.length > 0" label="Communes">
        <mat-option [value]="city" *ngFor="let city of cities; trackBy: trackByCity">
          <ng-container *ngIf="city.address">{{ city.address }} - </ng-container>{{ city.short }}
        </mat-option>
      </mat-optgroup>
    </ng-container>

    <ng-container *ngIf="(error$ | async) === true">
      <mat-optgroup label="Aucune suggestion ne correspond à votre saisie." class="mat-optgroup--error">
        <mat-option class="mat-option--error">
          Vérifiez qu&apos;il s&apos;agisse bien d&apos;un lieu ou qu&apos;il ne comporte pas de faute.
        </mat-option>
      </mat-optgroup>
    </ng-container>
  </mat-autocomplete>
</div>
